// ECLIPTICA — tokens em TypeScript, para onde o CSS não chega (gráficos, canvas, emails).
// Os valores são os mesmos de theme.css; o teste garante que não se desalinham.

export const colors = {
  goldLight: "#fff1c4",
  gold: "#e8c26a",
  goldDeep: "#a8792e",
  mist: "#9aa3c7",
  night: "#1b1f4a",
  deepNight: "#0b0c22",
  void: "#07080f",
  sun: "#ffb02e",
  moon: "#d6dcf2",
} as const;

export const aspects = { sol: colors.sun, lua: colors.moon, eclipse: "#d6c4ff" } as const;
export type Aspect = keyof typeof aspects;

export const rarities = { C: colors.mist, I: "#6fa8ff", R: colors.gold, M: "#e05cd0" } as const;
export type Rarity = keyof typeof rarities;

export const skins = ["site", "backoffice"] as const;
export type Skin = (typeof skins)[number];
